import { Policy, PolicyReceiptRule, PolicyRule } from 'src/types'
import { Option } from 'src/components/Formik/Select'

function rulesReduce(acc: Option[], cur: PolicyReceiptRule): Option[] {
  const text = `${cur.policy_receipt_rule_prefix}${
    cur.description ? ` - ${cur.description}` : ''
  }`
  return [
    ...acc,
    {
      label: text,
      title: text,
      value: `${cur.policy_receipt_rule_id}`
    }
  ]
}

function receiptRulesReduce(acc: Option[], cur: PolicyRule): Option[] {
  if (!cur.policy_receipt_rules?.length) {
    return acc
  }

  return [...acc, ...cur.policy_receipt_rules.reduce(rulesReduce, [])]
}

export function receiptRules(acc: Option[], cur: Policy): Option[] {
  if (!cur.policy_rules.length) {
    return acc
  }

  return [...acc, ...cur.policy_rules.reduce(receiptRulesReduce, [])]
}
